import i18n from './i18n'

const DEFAULT_LANGUAGE_CODE = 'pl'
const SUPPORTED_LANGUAGE_CODES = new Set(['pl', 'en'])

export const normalizeLanguageCode = (value: unknown): string => {
  if (typeof value !== 'string') {
    return DEFAULT_LANGUAGE_CODE
  }

  const trimmed = value.trim()
  if (!trimmed) {
    return DEFAULT_LANGUAGE_CODE
  }

  const normalized = trimmed.toLowerCase().replace('_', '-')
  const baseCode = normalized.split('-')[0]

  if (SUPPORTED_LANGUAGE_CODES.has(baseCode)) {
    return baseCode
  }

  return DEFAULT_LANGUAGE_CODE
}

export const getCurrentLanguageCode = () => normalizeLanguageCode(i18n.resolvedLanguage ?? i18n.language)
